import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { formatDecimalPart, parseDecimal } from '../../../utils/decimal'
import Modal from '../../organisms/modal/Modal'
import Asterisk from '../asterisk/Asterisk'

export default function Price({ className, disabled, infoUrl, prefix, price, primary, secondary, suffix, xs }) {
  const [modalOpen, setModalOpen] = useState(false)
  const { sign, wholePart, decimalPart } = parseDecimal(price)
  const formattedDecimalPart = formatDecimalPart(decimalPart, 2)
  const isSecondary = !primary && secondary // if in doubt default to primary

  return (
    <div
      className={clsx(
        className,
        'price',
        xs && 'price--xs',
        isSecondary && 'price--secondary',
        disabled && 'price--main-strike price--secondary-200',
        disabled && isSecondary && 'price--main-strike-secondary'
      )}
      data-testid="price"
    >
      {prefix && (
        <div className="price__before">
          <span className="price__prefix">{prefix}</span>
        </div>
      )}

      <div className="price__main">
        <span className="price__digits">
          {sign + wholePart}
          <span className="price__comma">,</span>
        </span>
      </div>

      <div className="price__after">
        <div className="price__after-top">
          {formattedDecimalPart === '00' ? (
            <span className="price__decimals price__decimals--dash">&ndash;</span>
          ) : (
            <span className="price__decimals">{formattedDecimalPart}</span>
          )}
          {infoUrl && (
            <>
              <span className="price__asterisk">
                <Asterisk onClick={() => setModalOpen(true)} />
              </span>

              <Modal open={modalOpen} onClose={() => setModalOpen(false)} hasCloseButton iframeSrc={infoUrl} />
            </>
          )}
        </div>
        {suffix && <span className="price__unit">{suffix}</span>}
      </div>
    </div>
  )
}

Price.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  infoUrl: PropTypes.string,
  prefix: PropTypes.string,
  price: PropTypes.string.isRequired,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  suffix: PropTypes.string,
  xs: PropTypes.bool
}

Price.defaultProps = {
  className: '',
  disabled: false,
  prefix: '',
  primary: false,
  secondary: false,
  suffix: '',
  xs: false
}
